import {Color} from '../enums/color';
import {TcddSubSystem} from '../enums/tcdd-sub-system.enum';
import {TractionSystemKeys} from '../constants/tcdd-system-keys/traction-system-keys';
import {BrakeSystemKeys} from '../constants/tcdd-system-keys/brake-system-keys';
import {PowerVoltageSystemKeys} from '../constants/tcdd-system-keys/power-voltage-system-keys';
import {TRACTION_SYSTEM} from '../constants/tcdd-system-contants/traction-system.contant';
import {BRAKE_SYSTEM} from '../constants/tcdd-system-contants/brake-system.constant';
import {POWER_VOLTAGE_SYSTEM} from '../constants/tcdd-system-contants/power-voltage-system.constant';

export class TcddTrainTextColorRules {
  protected rules: { [key in TcddSubSystem]: any };

  constructor() {
    this.rules = {
      [TcddSubSystem.MAIN_SYSTEM]: {},

      [TcddSubSystem.TEXT_SYSTEM]: {},

      [TcddSubSystem.TRACTION_SYSTEM]: {
        [TractionSystemKeys.tempMotorAx3]: (value: number) => {
          if (value && value < TRACTION_SYSTEM.MOTOR_TEMP_LOW) return Color.Gray;
          if (value && value > TRACTION_SYSTEM.MOTOR_TEMP_HIGH) return Color.Red;
          return Color.White;
        },
        [TractionSystemKeys.tempMotorAx4]: (value: number) => {
          if (value && value < TRACTION_SYSTEM.MOTOR_TEMP_LOW) return Color.Gray;
          if (value && value > TRACTION_SYSTEM.MOTOR_TEMP_HIGH) return Color.Red;
          return Color.White;
        },
        [TractionSystemKeys.tempTrcIn1]: (value: number) => {
          if (value && value < TRACTION_SYSTEM.TRC_TEMP_LOW) return Color.Gray;
          if (value && value > TRACTION_SYSTEM.TRC_TEMP_HIGH) return Color.Red;
          return Color.White;
        },
        [TractionSystemKeys.tempTrcIn2]: (value: number) => {
          if (value && value < TRACTION_SYSTEM.TRC_TEMP_LOW) return Color.Gray;
          if (value && value > TRACTION_SYSTEM.TRC_TEMP_HIGH) return Color.Red;
          return Color.White;
        },
        [TractionSystemKeys.tempTrcRec]: (value: number) => {
          if (value && value < TRACTION_SYSTEM.TRC_TEMP_LOW) return Color.Gray;
          if (value && value > TRACTION_SYSTEM.TRC_TEMP_HIGH) return Color.Red;
          return Color.White;
        }
      },

      [TcddSubSystem.SIGNALIZATION_SYSTEM]: {},

      [TcddSubSystem.COMMUNICATION_SYSTEM]: {},

      [TcddSubSystem.BRAKE_SYSTEM]: {
        [BrakeSystemKeys.mrpPress]: (value: number) => {
          if (value && value < BRAKE_SYSTEM.MRP_PRESS_MIN_LIMIT) return Color.Red;
          return Color.White;
        }
      },

      [TcddSubSystem.POWER_VOLTAGE_SYSTEM]: {
        [PowerVoltageSystemKeys.vacuumStatus]: (value: number) => {
          if (value && (value === POWER_VOLTAGE_SYSTEM.CUTTER_OPEN_FAILED ||
            value === POWER_VOLTAGE_SYSTEM.CUTTER_COMMISSION_FAILED ||
            value === POWER_VOLTAGE_SYSTEM.CUTTER_CANNOT_BE_COMMISSIONED)) {
            return Color.Red;
          }
          return Color.White;
        },
        [PowerVoltageSystemKeys.pantoStatus]: (value: number) => {
          if (value && (value === POWER_VOLTAGE_SYSTEM.PANTOGRAPH_LOWER_FAILED ||
            value === POWER_VOLTAGE_SYSTEM.SKA1_PANTOGRAPH_RAISE_FAILED ||
            value === POWER_VOLTAGE_SYSTEM.SKA2_PANTOGRAPH_RAISE_FAILED)) {
            return Color.Red;
          }
          return Color.White;
        },
        [PowerVoltageSystemKeys.measuringBatteryVoltage]: (value: number) => {
          if (value && value > POWER_VOLTAGE_SYSTEM.BATTERY_VOLTAGE_GRAY_THRESHOLD) return Color.Gray;
          if (value && value < POWER_VOLTAGE_SYSTEM.BATTERY_VOLTAGE_RED_THRESHOLD) return Color.Red;
          return Color.White;
        },
        [PowerVoltageSystemKeys.tempBattery]: (value: number) => {
          if (value && value < POWER_VOLTAGE_SYSTEM.BATTERY_TEMP_GRAY_THRESHOLD) return Color.Gray;
          if (value && value > POWER_VOLTAGE_SYSTEM.BATTERY_TEMP_RED_THRESHOLD) return Color.Red;
          return Color.White;
        },
        [PowerVoltageSystemKeys.tractionTransformerTemperatureTcu]: (value: number) => {
          if (value && value < POWER_VOLTAGE_SYSTEM.TRANSFORMER_TCU_GRAY_THRESHOLD) return Color.Gray;
          if (value && value > POWER_VOLTAGE_SYSTEM.TRANSFORMER_TCU_RED_THRESHOLD) return Color.Red;
          return Color.White;
        }
      },

      [TcddSubSystem.AIR_CONDITION_SYSTEM]: {},

      [TcddSubSystem.DOOR_SYSTEM]: {},

      [TcddSubSystem.OTHER_SYSTEM]: {}
    };
  }

  getRule(systemName: string) {
    return this.rules[systemName] ?? null;
  }
}
